import styled from '@emotion/styled';
import BazaarVoiceRatings from '../../atoms/bazaar-voice/ratings';

/**
 * ProductCardInlineRatings: Style Wrapper
 * Style wrapper BazaarVoiceRatings container in Algolia PLP Product Cards
 * * The [order, align-self] attributes position the ratings container in the card
 * * The .bv_text class includes the score meta and is hidden to prevent "0.0 (0)"
 */
const ProductCardInlineRatings = styled(BazaarVoiceRatings)`
  order: 3;
  align-self: flex-start;
  & .bv_text {
    display: none !important; // TODO: Unhide when we have reviews to show
  }
`;

/**
 * ProductCardRatings: Contextual / Data Wrapper
 * This is a wrapper for the BV Ratings container in Algolia PLP Product Cards
 * @param {string} productId - The BV productID to show ratings for, planned: `slug` from Algolia
 * @returns {JSX.Element} - The Product Card Ratings container with stars, avg rating, and count
 * @example
 *   <ProductCardRatings productId="anna-dress" />
 * @example
 *   <ProductCardRatings productId={AlgoliaProductHit.slug} />
 * @see https://knowledge.bazaarvoice.com/wp-content/conversations/en_US/Display/inline_ratings.html
 */
const ProductCardRatings = ({ productId = 'product1' }) => (
  <ProductCardInlineRatings show="inline_rating" productId={productId} />
);

export default ProductCardRatings;
